var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VSelect',{attrs:{"items":_vm.source,"multiple":"","label":_vm.$t('common.selectHeaders'),"item-value":"value"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(item.text))+" ")]}},{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_vm._v(" "+_vm._s(_vm.$t(item.text))+" "),(index + 1 < _vm.selectedHeaders.length)?[_vm._v(",")]:_vm._e()]}}]),model:{value:(_vm.selectedHeaders),callback:function ($$v) {_vm.selectedHeaders=$$v},expression:"selectedHeaders"}})}
var staticRenderFns = []

export { render, staticRenderFns }